<!-- <div class="video-container">
    <video #videoTarget class="video-js vjs-default-skin" preload="auto"></video>
    <div *ngIf="isBuffering" class="spinner">
      Loading... {{ bufferPercentage }}%
    </div>
    <div class="controls">
      <button (click)="seekBackward()">⏪ Backward 10s</button>
      <button (click)="seekForward()">⏩ Forward 10s</button>
    </div>
  </div> -->
  
  <div class="video-container">
    <video #videoTarget class="video-js vjs-default-skin" controls preload="auto"></video>
    <div *ngIf="isBuffering" class="loading-overlay">
      Loading... {{ bufferPercentage }}%
    </div>
  </div>
  